module.exports = __webpack_public_path__ + "static/media/radio-alt.ac47e01f.svg";